// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"136":"c6903b96","175":"6c4dc95b","481":"41932367","827":"fc544322"}[chunkId] + ".css";
};